const ValidationService = {
    isEmail(string) {
        return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            .test(string.toLowerCase());
    },
    isTextValid(text, pattern) {
        const regex = new RegExp(pattern);
        return regex.test(text);
    },
};

export { ValidationService as V };

//# sourceMappingURL=index9.js.map